import { render, staticRenderFns } from "./QueryCatalogMenu.vue?vue&type=template&id=5f904dff&"
import script from "./QueryCatalogMenu.vue?vue&type=script&lang=js&"
export * from "./QueryCatalogMenu.vue?vue&type=script&lang=js&"
import style0 from "./QueryCatalogMenu.vue?vue&type=style&index=0&id=5f904dff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports